import { Link } from "react-router-dom";
import { CATEGORIES } from "@/mocks/gossip";

export default function CategoryRail() {
  return (
    <section className="bg-background-100 border-y border-background-200 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-medium text-secondary-600 bg-secondary-100 rounded-full px-3 py-1 mb-3">
              <i className="ri-archive-line"></i> 围观现场
            </span>
            <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
              按栏目前排就座
            </h2>
          </div>
          <p className="text-sm text-foreground-500 max-w-sm hidden md:block">
            选一个你感兴趣的现场，快速找到正在发生的热门事件与讨论焦点。
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {CATEGORIES.map((c) => (
            <Link
              key={c.id}
              to="#feed"
              onClick={(e) => e.preventDefault()}
              className="group rounded-2xl bg-background-50 border border-background-200 p-5 text-center hover:border-secondary-300 hover:bg-white transition"
            >
              <span className="mx-auto w-12 h-12 flex items-center justify-center rounded-2xl bg-secondary-100 text-secondary-700 group-hover:bg-secondary-500 group-hover:text-background-50 transition">
                <i className={`${c.icon} text-xl`}></i>
              </span>
              <h3 className="mt-3 text-sm font-bold text-foreground-900">{c.name}</h3>
              <p className="mt-1 text-xs text-foreground-400 leading-relaxed line-clamp-2">
                {c.desc}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}